<template>
  <div class="address-selector-wrapper">
    <!-- 上次地址提示 -->

    <el-popover
        placement="bottom-start"
        width="380"
        trigger="click"
        v-model="popoverVisible"
        popper-class="address-selector-popover"
    >
      <!-- 弹出内容 -->
      <template #reference>
        <el-button
            size="small"
            type="primary"
            :disabled="!customerId"
            icon="el-icon-location-outline"
            class="select-address-btn"
        >
          选择地址
        </el-button>
      </template>

      <!-- 顶部功能说明 -->
      <el-alert
          v-if="customerId"
          title="选择客户地址，快速导入到订单收货地址栏中，导入后仍可手动修改。"
          type="info"
          show-icon
          :closable="false"
          class="top-tip"
      />

      <!-- 顶部控制栏 -->
      <div class="selector-options" v-if="customerId">
        <div class="checkbox-group">
          <el-checkbox v-model="includeName">导入姓名</el-checkbox>
          <el-checkbox v-model="includePhone">导入电话</el-checkbox>
        </div>
        <el-tooltip content="选择后将自动填入地址字段，可选导入电话与姓名" placement="top">
          <el-button type="text" icon="el-icon-info" size="mini"></el-button>
        </el-tooltip>
      </div>

      <!-- 没有客户提示 -->
      <div v-if="!customerId" class="no-customer-tip">
        请先选择客户信息后再选择地址
      </div>

      <!-- 地址列表 -->
      <div class="address-list scroll-wrapper" v-if="customerId">
        <el-scrollbar>
          <div
              class="address-card"
              v-for="item in addressList"
              :key="item.id"
              @click="selectAddress(item)"
          >
            <div class="card-header">
              <div class="card-name-phone">
                <span class="name">{{ item.name }}</span>
                <span class="phone">{{ item.telNum }}</span>
              </div>
              <el-tag
                  v-if="item.type === '常用'"
                  size="mini"
                  type="success"
                  class="common-tag"
              >常用</el-tag>
            </div>

            <div class="card-address">
              {{ formatFullAddress(item) }}
            </div>

            <div class="card-operator">
              创建人：{{ item.operatorName || '未知' }}
            </div>
          </div>
        </el-scrollbar>

        <el-empty
            v-if="addressList.length === 0"
            description="暂无地址"
            class="empty-box"
        />
        <el-button type="primary" size="mini" @click="addressVisible = true">
          立即创建
        </el-button>
      </div>
    </el-popover>
    <customer-address
        :visible.sync="addressVisible"
        :customer-id="customerId">
    </customer-address>
  </div>
</template>

<script>
export default {
  name: "AddressSelector",
  props: {
    customerId: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Object],
      default: "",
    },
  },
  data() {
    return {
      popoverVisible: false,
      addressList: [],
      includeName: false,
      includePhone: false,
      addressVisible: false, // 控制新建地址弹窗

    };
  },
  watch: {
    popoverVisible(val) {
      if (val && this.customerId) {
        this.loadAddressList();
      }
    },
  },
  methods: {
    fillLastAddress() {
      if (this.lastUsedAddress) {
        this.$emit("input", this.lastUsedAddress)
      }
    },
    loadAddressList() {
      this.$http.get("/customerAddress/addressList", {
            params: { customerId: this.customerId },
          })
          .then((res) => {
            if (res.data.success) {
              this.addressList = (res.data.resultObj || []).map((addr) => ({
                ...addr,
                addressCode: addr.addressCode ? addr.addressCode.split(",") : [],
              }));
            } else {
              this.$message.error(res.data.message || "加载地址失败");
            }
          })
          .catch(() => {
            this.$message.error("网络错误");
          });
    },
    formatFullAddress(item) {
      return `${(item.addressCode || []).join(" ")} ${item.address}`;
    },
    selectAddress(item) {
      const fullAddress = this.formatFullAddress(item);
      let resultParts = [];

      if (this.includeName) resultParts.push(item.name);
      if (this.includePhone) resultParts.push(item.telNum);
      resultParts.push(fullAddress);

      const resultString = resultParts.join(" ");
      this.$emit("input", resultString);
      this.popoverVisible = false;
    },
  },
};
</script>

<style scoped>
.address-selector-wrapper {
  display: inline-block;
}

.address-selector-popover {
  padding: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: visible;
}

.select-address-btn {
  border-radius: 20px;
  padding: 5px 16px;
  font-weight: 500;
}

.top-tip {
  margin: 0;
  padding: 8px 12px;
  font-size: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.selector-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  font-size: 13px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #eee;
}

.checkbox-group {
  display: flex;
  gap: 12px;
}

.no-customer-tip {
  padding: 24px;
  font-size: 14px;
  color: #f56c6c;
  text-align: center;
}

.scroll-wrapper {
  max-height: 280px;
  overflow-y: auto;
}

.scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}
.scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.address-card {
  background: #fff;
  padding: 12px;
  margin: 10px;
  border-radius: 10px;
  border: 1px solid #ebebeb;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.address-card:hover {
  background: #f5faff;
  border-color: #409eff;
  box-shadow: 0 4px 10px rgba(64, 158, 255, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.card-name-phone {
  display: flex;
  gap: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.common-tag {
  padding: 0 6px;
  line-height: 20px;
}

.card-address {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 6px;
}

.card-operator {
  font-size: 12px;
  color: #999;
  text-align: right;
}

.empty-box {
  padding: 20px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// addressSelector.vue?3a2498de